import {
  Component,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { TabsContentUser } from '../../../../../../shared/models/tabs-content-user';
import { UserDetailsExternalAccountComponent } from '../user-details-tab/user-details-external-account/user-details-external-account.component';
import { UserDetailsConnectionHistoryComponent } from '../user-details-tab/user-details-connection-history/user-details-connection-history.component';
import { UserDetailsSalesObjectivesRulesComponent } from '../user-details-tab/user-details-sales-objectives-rules/user-details-sales-objectives-rules.component';

@Component({
    selector: 'app-user-tabs-details',
    templateUrl: './user-tabs-details.component.html',
    styleUrls: ['./user-tabs-details.component.scss'],
    standalone: false
})
export class UserTabsDetailsComponent implements OnInit, OnChanges, OnDestroy {
  active = 1;
  currentActive: number = 1;

  tabsContent$: BehaviorSubject<TabsContentUser[]> = new BehaviorSubject<
    TabsContentUser[]
  >([]);

  tabsInit: TabsContentUser[] = [
    {
      title: 'USER_TABS_EXTERNAL_ACCOUNT',
      index: 1,
      name: 'external',
      component: UserDetailsExternalAccountComponent,
    },
    {
      title: 'USER_TABS_CONNECTION_HISTORIES',
      index: 2,
      name: 'connectionHistory',
      component: UserDetailsConnectionHistoryComponent,
    },
    {
      title: 'USER_TABS_SALES_OBJECTIVES_RULES',
      index: 3,
      name: 'salesObjectivesRules',
      component: UserDetailsSalesObjectivesRulesComponent,
    },
  ];

  ngOnInit(): void {
    this.tabsContent$.next(this.tabsInit);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.currentActive) {
      this.active = this.currentActive;
    } else {
      this.active = 1;
    }
    this.tabsContent$.next(this.tabsInit);
  }

  trackByTabsContent(index: any, item: TabsContentUser) {
    return item.index;
  }

  onActiveIdChangeSaveCurrent(active: number) {
    this.currentActive = active;
  }

  ngOnDestroy(): void {
    this.currentActive = 0;
  }
}
